import { Link } from 'react-router-dom';

interface ArticleCardProps {
  title: string;
  excerpt: string;
  cover: string;
  category: string;
  date: string;
  readTime: string;
  slug: string;
}

export default function ArticleCard({
  title,
  excerpt,
  cover,
  category,
  date,
  readTime,
  slug,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="block group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="aspect-[16/9] overflow-hidden">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-3 mb-3">
          <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full whitespace-nowrap">
            {category}
          </span>
          <span className="text-xs text-foreground-400 whitespace-nowrap">{date}</span>
          <span className="text-xs text-foreground-400 whitespace-nowrap">{readTime}阅读</span>
        </div>
        <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
          {excerpt}
        </p>
      </div>
    </Link>
  );
}